<template>
  <div>
    <el-dialog :title="uploadTitle" width="1000px" center :visible.sync="showUpload" :append-to-body="true"  @close="beforeClose">
        <el-progress v-if='showProgress' :percentage="progress"></el-progress>
        <!-- iframe视频 -->
        <div v-if="isIframe && fileType === 'video'" class="top-video-switch">
          <el-tabs class="lb-tabs" v-model="activeName">
            <el-tab-pane label="本地视频" name="1">
              <div v-loading="loading" class="img-view">
                  <div
                  class="img-item"
                  v-for="(item,index) in fileList"
                  :key='index'
                  :style="{'background-image': `url(${lbFileType === 'image' ? item.url : defaultBGImg})`}"
                  @click="choiceImg(index)"
                  >
                      <div class="img-name">{{item.filename}}</div>
                      <i v-show='item.checked' class="icon-selected el-icon-check"></i>
                      <i
                      class="icon-d el-icon-delete-solid"
                      @click.stop="confirmDel('single',item.id)"
                      ></i>
                  </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="提取网络视频" name="2">
              <div class="get-network-video">
                <lb-image  src="http://longbingcard.xiaochengxucms.com/images/143/2019/09/f9699qu9QgWFqFlG95qhR62oUhr9m2.jpg" />
                <el-input v-model="networkVideo" placeholder="请填写通用代码"></el-input>
                <lb-button type='primary' @click="getNetWorkVideo">提 取</lb-button>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <!-- 图片视频音频 -->
        <div v-else >
          <div v-if="!paramData.methodModel" style="padding-bottom:20px">
            <el-button size="small" @click="showGroup = true">管理分组</el-button>
        </div>
        <el-tabs  v-model="editableTabsValue" @tab-click="Initialize"  type="card"  @tab-remove="removeTab">
          <el-tab-pane
            :key="goodItem.id"
            v-for="goodItem in editableTabs"
            :label="goodItem.name"
            :name="goodItem.name"
          >
        <div  v-loading="loading" class="img-view">
            <div
            class="img-item"
            v-for="(item,index) in fileList"
            :key='index'
            :style="{'background-image': `url(${lbFileType === 'image' ? item.url : defaultBGImg})`}"
            @click="choiceImg(index)"
            >
                <div class="img-name">{{item.filename}}</div>
                <i v-show='item.checked' class="icon-selected el-icon-check"></i>
                <block v-if="paramData.methodModel"></block>
                <i
                class="icon-d el-icon-delete-solid"
                @click.stop="confirmDel('single',item.id)"
                v-else></i>
            </div>
        </div>
        </el-tab-pane>
        </el-tabs>
        </div>
        <div class="upload-page">
            <div class="operate" v-if="paramData.methodModel">
              <lb-button size='mini' type='primary' @click="selectedImgs">{{$t('action.comfirm')}}</lb-button>
            </div>
            <div class="operate" v-else>
              <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="checkAll"
              @change="handleCheckAllChange"
              >{{$t('action.checkAll')}}</el-checkbox>
              <el-divider direction="vertical"></el-divider>
              <div>
                  <span>{{$t('action.selected')}}</span>
                  <span class="count">{{selectedFiles.length}}</span>
                  <span>{{$t('action.toSelected')}}</span>
                  <span class="count">{{fileSizeNumber - filesLength}}</span>
              </div>
              <lb-button size='mini' type='primary' @click="selectedImgs">{{$t('action.comfirm')}}</lb-button>
              <lb-button size='mini' type='danger' @click="confirmDel('more')">{{$t('action.delete')}}</lb-button>

              <el-divider direction="vertical"></el-divider>
              <lb-button size='mini' type='primary' @click="$refs['inputImg'].click()">{{$t('action.upload')}}</lb-button>
              <input type="file" :accept="acceptType" :multiple='lbFileType === "image"' style="display:none" @change="uploadFiles" ref="inputImg">
            </div>
            <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="page"
            :page-size="limit"
            layout="total, prev, pager, next"
            :total="total">
            </el-pagination>
        </div>
    </el-dialog>
     <el-dialog width="375px" center :visible.sync="showGroup"  :append-to-body="true">
      <ul class="infinite-list" style="overflow:auto">
        <div class="group_item" v-for="(item,index) in editableTabs" :key="index">
          <div class="fen_item">
            <i class="el-icon-folder"></i>
            <span v-if="item.name!=='全部'" @click="addShowGroup(index)" style="padding-left:20px;cursor:pointer">{{ item.name }}</span>
            <span v-else style="padding-left:20px;cursor:pointer">{{ item.name }}</span>
          </div>
          <el-checkbox v-show="item.name!=='全部'" v-model="item.checked"   @change="changeBox($event,index)"></el-checkbox>
        </div>
      </ul>
      <div class="btn_view">
        <el-button type="primary" size="small" @click="showGroup=false" plain>取消</el-button>
        <el-button type="danger" :disabled="isDisable" size="small" @click="delgroup">删除</el-button>
        <el-button type="primary" size="small" @click="addShowGroup()">新增</el-button>
      </div>
    </el-dialog>

    <el-dialog title="请输入分组名称" :visible.sync="showAddGroup" width="30%" center>
    <el-form  @submit.native.prevent :model="addForm" :rules="groupRules"  ref="addForm">
      <el-form-item prop="name">
          <el-input v-model="addForm.name" :maxlength="20" type="text" placeholder="请输入内容"></el-input>
      </el-form-item>
    </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddGroup = false">取 消</el-button>
        <el-button type="primary" @click="subMitGroup">确 定</el-button>
      </span>
    </el-dialog>

    </div>
</template>

<script>

export default {
  props: {
    visibles: {
      type: Boolean,
      default: false
    },
    fileType: {
      type: String,
      default: 'image'
    },
    fileSize: {
      type: Number,
      default: 9
    },
    paramData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isIframe: {
      type: Boolean,
      default: false
    },
    filesLength: {
      type: Number,
      default: 0
    },
    multilineType: {
      type: String,
      default: 'single'
    }
  },
  data () {
    return {
      addForm: {
        name
      },
      groupRules: {
        name: {
          required: false,
          type: 'string',
          message: '请输入分组名',
          trigger: 'blur'
        }
      },
      isDisable: false, // 是否禁用删除
      updateGropId: false, // 分组id
      group_index: 0, // 选中index
      selectIds: [],
      groupGoods: [

      ],
      name: '',
      showAddGroup: false, // 显示输入框
      groups: [
        {
          name: '全部',
          id: 0,
          conent: ''
        }
      ], // 分类信息
      showGroup: false, // 是否显示分组信息
      editableTabsValue: '全部', // 分组index
      editableTabs: [],
      activeName: '1',
      networkVideo: '',
      loading: false,
      page: 1,
      limit: 10,
      total: 0,
      showUpload: false,
      isIndeterminate: false,
      checkAll: false,
      defaultBGImg: '', // 不是图片类型时的列表默认背景图
      fileList: [], // 图片、视频、音频列表数据
      uploadTitle: '', // 上传的标题
      lbFileType: 'image', // 文件类型
      acceptType: 'image/*', // 上传的文件类型
      progress: 0,
      fileSizeNumber: '',
      showProgress: false,
      checkedFiles: {},
      fileLen: this.filesLength
    }
  },
  created () {
    if (this.multilineType === 'single' || this.fileType === 'video') {
      this.fileSizeNumber = 1
    } else {
      this.fileSizeNumber = this.fileSize
    }

    this.Initialize()
  },
  methods: {
    Initialize () {
      this.handleFileType(this.fileType)
      this.getGroups()
      this.page = 1
      this.selectIds = []
    },
    // 删除单个tab
    removeTab (targetName) {
      let tabs = this.editableTabs
      let activeName = this.editableTabsValue
      if (targetName === '全部') {
        return
      }
      // 调用确认框 回调执行函数
      this.configGroup(() => {
        let goodIndex = 0
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            goodIndex = index
            if (activeName === targetName) {
              let nextTab = tabs[index + 1] || tabs[index - 1]
              if (nextTab) {
                activeName = nextTab.name
              } else {
                activeName = '全部'
              }
            }
          }
        })
        this.$api.delGroup({group_id: tabs[goodIndex].id}).then(res => {
          if (res.code === 200) {
            this.editableTabsValue = activeName
            this.editableTabs = tabs.filter(tab => tab.name !== targetName)
            this.Initialize()
          }
        })
      })
    },
    changeBox (e, index) {
      this.$nextTick(() => {
        this.$refs.addForm.resetFields()
      })
      this.editableTabs[index].checked = e
      let id = this.editableTabs[index].id
      if (this.editableTabs[index].checked) {
        let goodIndex = this.selectIds.indexOf(id)
        if (goodIndex === -1) {
          this.selectIds.push(id)
        }
      } else {
        let goodIndex = this.selectIds.indexOf(id)
        if (goodIndex !== -1) {
          let fils = this.selectIds
          this.selectIds = fils.filter((item, itemIndex) => {
            return item !== id
          })
        }
      }
      console.log(this.selectIds)
    },
    // 删除多个tab
    delgroup () {
      if (this.selectIds.length === 0) {
        return this.$message.warning(`请选择分组！`)
      }
      this.configGroup(() => {
        // let ids = JSON.stringify(this.selectIds)
        this.$api.delGroups({ group_id: this.selectIds }).then(res => {
          this.showGroup = false
          if (res.code === 200) {
            // let tabs = this.editableTabs
            // let activeName = this.editableTabsValue
            // tabs.forEach((item, index) => {
            //   let goodIndex = this.selectIds.indexOf(item.id)
            //   if (goodIndex !== -1) {
            //     let nextTab = tabs[index - 1] || tabs[index + 1]
            //     let nextTabIndex = this.selectIds.indexOf(nextTab.id)
            //     if (nextTab && nextTabIndex === -1) {
            //       activeName = nextTab.name
            //     }
            //   }
            // })
            // this.editableTabsValue = activeName
            this.editableTabsValue = '全部'
            this.selectIds = []
            this.Initialize()
          }
        })
      })
    },
    subMitGroup () {
      this.showAddGroup = false
      let { name } = this.addForm
      if (name.split(' ').join('').length > 0) {
        if (this.updateGropId) {
          this.$api.updateGroup({
            group_id: this.updateGropId,
            group: {name: name}
          }).then(res => {
            this.editableTabsValue = '全部'
            this.updateGropId = ''
            this.Initialize()
          })
        } else {
          this.$api.addGroup({ name }).then(res => {
            this.Initialize()
          })
        }
      } else {
        this.$message.warning(`请输入分组名字!`)
      }
    },
    addShowGroup (index) {
      if (index && !this.isDisable) {
        this.name = this.editableTabs[index].name
        this.updateGropId = this.editableTabs[index].id
      } else {
        this.addForm.name = ''
      }
      this.showGroup = false
      if (this.editableTabs.length <= 20) {
        this.showAddGroup = true
      } else {
        this.$message.warning(`最多可添加20个分组!`)
      }
    },
    /**
     * @method 根据fileType处理不同的文件类型
     */
    handleFileType (type) {
      this.lbFileType = type
      // this.uploadTitle = `title.${type}Upload`
      this.uploadTitle = this.paramData.methodModel ? this.paramData.uploadTitle : `${this.$t(`title.${type}Upload`)}`

      this.acceptType = `${type}/*`
      if (type !== 'image') this.defaultBGImg = require(`@/assets/${type}.png`)
      if (this.showUpload) this.getFileList()
    },
    getGroups () {
      this.$api.getGroupsList().then(res => {
        if (res.data.groups.length === 0) {
          this.isDisable = true
        } else {
          this.isDisable = false
        }
        if (this.paramData.methodModel) {
          this.editableTabs = [
            {
              name: '全部',
              id: 0,
              conent: ''
            }
          ]
          // this.groups = [{
          //   name: '全部',
          //   id: 0,
          //   conent: ''
          // }]
        } else {
          this.editableTabs = [
            {
              name: '全部',
              id: 0,
              conent: ''
            }
          ]
          // this.groups = [{
          //   name: '全部',
          //   id: 0,
          //   conent: ''
          // }]
          res.data.groups.map(item => {
            item.checked = false
            this.editableTabs.push(item)
          })
        }
        console.log(this.editableTabs)
      })
    },
    beforeClose () {
      this.fileLen = this.filesLength
      this.checkedFiles = {}
      this.showUpload = false
    },
    /**
     * @method 获取图片、音频、视频
     */
    getFileList () {
      let tabs = this.editableTabs
      tabs.forEach((item, index) => {
        if (item.name === this.editableTabsValue) {
          this.group_index = index
        }
      })
      let groupGoods = this.editableTabs[this.group_index]
      this.loading = true
      let {page, limit, lbFileType, paramData} = this
      let type = lbFileType === 'image' ? 1 : lbFileType === 'audio' ? 2 : lbFileType === 'video' ? 3 : 4
      let options = ''
      if (this.group_index !== 0) {
        options = {
          page: page,
          limit: limit,
          type: type,
          group_id: groupGoods.id
        }
      } else {
        options = {
          page: page,
          limit: limit,
          type: type,
          group_id: ''
        }
      }

      if (paramData.methodModel) {
        let {param} = paramData
        param.page = page
        param.limit = limit
        this.$api[paramData.methodModel](param).then(res => {
          this.loading = false
          if (res.code === 200) {
            console.log(res)
            this.fileList = res.data.data.map(item => {
              item.checked = false
              item.url = item.img || item.cover
              item.filename = item.title
              return item
            })
            this.total = res.data.total
          }
        })
      } else {
        this.$api.getUploadFiles(options).then(res => {
          this.loading = false
          if (res.code === 200) {
            this.fileList = res.data.files.map(item => {
              item.checked = false
              item.url = item.longbing_attachment_path || item.attachment
              return item
            })
            this.total = res.data.total
          }
        })
      }
    },
    configGroup (func) {
      this.$confirm('你确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (typeof func === 'function') {
          func()
        }
        // this.$message({
        //   type: 'success',
        //   message: '删除成功!'
        // })
      })
      // .catch(() => {
      //   this.$message({
      //     type: 'info',
      //     message: '已取消删除'
      //   })
      // })
    },
    /**
     * @method 切换分页
     */
    handleCurrentChange (val) {
      this.checkedFiles = {}
      this.fileLen = this.filesLength
      this.page = val
      this.getFileList()
    },

    /**
     * @method 全选
     */
    handleCheckAllChange () {
      let {fileSizeNumber, fileLen: selectNum} = this
      let length = Object.values(this.checkedFiles).length
      if (length === fileSizeNumber) {
        this.checkedFiles = []
        this.fileList.forEach((item, index) => {
          item.checked = false
        })
        return
      }
      this.fileList.forEach((item, index) => {
        if (selectNum === fileSizeNumber) {
          return
        }
        if (item.checked) {
          selectNum++
        } else {
          item.checked = !item.checked
          selectNum++
        }
        this.checkedFiles['file' + index] = item
      })
      this.fileLen = selectNum
      // console.log(this.fileList, this.checkedFiles, '全选')
    },
    /**
     * @method 选中的图片、视频、音频
     */
    choiceImg (index) {
      // alert(this.fileLen + '_' + this.fileSize)
      // if (!this.isIframe && this.multilineType !== 'single' && !this.fileList[index].checked && this.selectedFiles.length >= this.fileSizeNumber) {
      if (!this.isIframe && this.multilineType !== 'single' && !this.fileList[index].checked && this.fileLen >= this.fileSize) {
        console.log(this.isIframe, this.multilineType, this.fileLen)
        this.$message.warning(`最多可添加${this.fileSizeNumber}张!`)
        return false
      } else {
        if (this.multilineType === 'single') {
          this.fileLen = 0
          this.fileList.map(item => {
            item.checked = false
          })
        }
        if (this.fileList[index].checked) this.fileLen--
        else this.fileLen++
        this.fileList[index].checked = !this.fileList[index].checked
        if (this.fileList[index].checked) {
          this.checkedFiles['file' + index] = this.fileList[index]
        } else {
          delete this.checkedFiles['file' + index]
        }
        let arr = this.fileList.filter(item => {
          return item.checked
        })
        this.isIndeterminate = arr.length > 0 && arr.length < this.fileList.length
        this.checkAll = arr.length === this.fileList.length
      }
    },

    /**
     * @method 删除确认框
     */
    confirmDel (type, fid) {
      if (type === 'more' && this.selectedFiles.length === 0) return false
      this.$confirm(this.$t('tips.confirmDelete'), this.$t('tips.reminder'), {
        confirmButtonText: this.$t('action.comfirm'),
        cancelButtonText: this.$t('action.cancel'),
        type: 'warning'
      }).then(() => {
        let ids = []
        if (type === 'more') {
          ids = this.selectedFiles.map(item => {
            return item.id
          })
        } else ids = [fid]
        this.$api.delFiles({ids}).then(res => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: this.$t('tips.successDel')
            })
            this.getFileList()
          }
        })
      })
    },

    /**
     * @method 上传图片，视频，音频
     */
    uploadFiles (e) {
      let {lbFileType} = this
      let files = e.target.files
      if (files.length === 0) return false
      let formData = new FormData()
      for (let i = 0, len = files.length; i < len; i++) {
        formData.append('file[]', files[i])
      }
      let tabs = this.editableTabs
      tabs.forEach((item, index) => {
        if (item.name === this.editableTabsValue) {
          this.group_index = index
        }
      })
      let groupGoods = this.editableTabs[this.group_index]
      let groupId = groupGoods.id
      formData.append('group_id', groupId)
      formData.append('type', lbFileType === 'image' ? 'picture' : lbFileType)
      this.progress = 0
      this.showProgress = true
      this.$api.uploadFiles(formData, this.getProgress).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('tips.successUpload'))
          this.getFileList()
        }
      })
    },

    /**
     * @method 提取网络视频
     */
    getNetWorkVideo () {
      let {networkVideo} = this
      let _html = ''
      if (networkVideo.indexOf('<iframe') >= 0) {
        let htmlArr = networkVideo.split('src')
        _html = htmlArr[0] + ` wdith='300' height='200' src` + htmlArr[1]
      } else {
        _html = `<iframe frameborder="0" src="${networkVideo}" wdith='300' height='200' allowFullScreen="true"></iframe>`
      }
      this.$emit('selectedFiles', [{type: 5, url: _html}])
      this.showUpload = false
    },

    /**
     * @method 获取上传的进度
     */
    getProgress (e) {
      this.progress = e.loaded / e.total * 100 | 0
      if (this.progress >= 100) {
        setTimeout(() => {
          this.showProgress = false
        }, 500)
      }
    },

    /**
     * @method 点击确定选中的图片
     */
    selectedImgs () {
      let {fileList, checkedFiles} = this
      let checkedImgs = Object.values(checkedFiles)
      fileList.forEach(item => {
        item.checked = false
      })
      this.$emit('selectedFiles', checkedImgs)
      this.showUpload = false
      this.checkedFiles = {}
    }
  },
  watch: {
    showAddGroup (val) {
      this.$nextTick(() => {
        this.$refs.addForm.resetFields()
      })
    },
    showUpload (val) {
      this.editableTabsValue = '全部'
      this.selectIds = []
      this.getGroups()
      if (!val) {
        // let goodIndex = parseInt(this.editableTabsValue.split('&')[1])
        // let groupGoods = this.editableTabs[goodIndex]
        // groupGoods.content = []
        // this.fileList = []
        this.page = 1
        this.total = 0
      }
      this.$emit('update:visibles', val)
    },
    visibles (val) {
      this.handleFileType(this.fileType)
      this.showUpload = val
      if (val) {
        this.getFileList()
      }
    },
    fileList: {
      deep: true,
      handler (val) {
        let checkedArr = val.filter(item => {
          return item.checked
        })
        this.checkAll = checkedArr.length === val.length && val.length !== 0
        this.isIndeterminate = checkedArr.length > 0 && checkedArr.length < val.length
      }
    },
    filesLength (val) {
      this.fileLen = val
    }
  },
  computed: {
    selectedFiles () {
      return this.fileList.filter(item => {
        return item.checked
      })
    }
  },
  filters: {
    filterCheked (arr) {
      let a = arr.filter(item => {
        return item.checked
      })
      return a.length
    }
  },
  beforeDestroy () {
    this.$store.commit('handleUploadStatus', false)
  }
}
</script>

<style lang="scss" scoped>
.fen_item {
  display: flex;
  align-items: center;
}
.group_item {
  display: flex;
  margin: 10px 0;
  align-items: center;
  justify-content: space-between;
}
.btn_view {
  margin: 0 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
    .img-view{
        width: 100%;
        height: 398px;
        padding: 20px 0;
        // border-top: 1px solid $lineColor;
        border-bottom: 1px solid $lineColor;
        display: flex;
        flex-wrap: wrap;
        position: relative;
        .loading{
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, 50%);
        }
        .img-item{
            width: 16%;
            height: 140px;
            background-color: $columnBgColor;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center center;
            margin: 2%;
            position: relative;
            border:2px solid $columnBgColor;
            cursor: pointer;
            .img-name{
                width: 100%;
                height: 32px;
                position: absolute;
                bottom: 0px;
                right: 0;
                left: 0;
                margin: auto;
                background: rgba($color: #000000, $alpha: 0.5);
                z-index: 10;
                line-height: 32px;
                color: #fff;
                padding: 0 20px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .icon-selected{
                display: inline-block;
                width: 100%;
                height: 100%;
                background: rgba($color: #000000, $alpha: 0.5);
                position: absolute;
                top: 0;
                left: 0;
                z-index: 15;
                color: #fff;
                font-size: 60px;
                display: flex;
                justify-content: center;
                align-items: center;
            }
            .icon-d{
                display: none;
                width: 32px;
                height: 32px;
                background: #4C88D8;
                color: #fff;
                text-align: center;
                line-height: 32px;
                position: absolute;
                right: 0;
                bottom: 0;
                z-index: 20;
                font-size: 20px;
            }
            &:hover{
                border:2px solid #4C88D8;
                width: 16%;
                .icon-d{
                    display: inline-block;
                }
            }
        }
    }
    .lb-tabs .img-view{
      border-top: none;
    }
    .top-video-switch{
      width: 100%;
      border-bottom: 1px solid $lineColor;
    }
    .get-network-video{
      height: 398px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      .el-input{
        width: 500px;
      }
    }
    .upload-page{
        margin-top: 20px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .operate{
            display: flex;
            align-items: center;
            .el-checkbox{
              margin-right: 10px;
            }
            .count{
                color: #4C88D8;
                margin-left: 5px;
                margin-right: 10px;
            }
            .el-button{
                margin-left: 10px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/basics/lbUpload.vue